/* Veyra · caja de compra v2 · 2026-10-07
   Tarjetas 1·2·3 bolsas + desplegable de sabor que muestra SOLO las combinaciones
   del número de bolsas elegido. Todo sale del JSON que pinta vy-caja-v2.liquid
   (las variantes reales del producto): si mañana se crea otra mezcla en Shopify,
   aparece sola en el desplegable. */
(function () {
  var fmt = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 2, minimumFractionDigits: 0 });
  function dinero(c) { return fmt.format(c / 100).replace(/\.00$/, ''); }

  /* «Cinnamon Cacao» con n bolsas → ['C','C'] · «2 Cacao + 1 Vanilla» → ['C','C','V'] */
  function composicion(sabor, n) {
    var m = /(\d+)\s*Cacao\s*\+\s*(\d+)\s*Vanilla/i.exec(sabor);
    if (m) return Array(+m[1]).fill('C').concat(Array(+m[2]).fill('V'));
    return Array(n).fill(/vanilla/i.test(sabor) ? 'V' : 'C');
  }
  function etiqueta(sabor, n) {
    if (/\+/.test(sabor)) return sabor;
    return n > 1 ? n + ' ' + sabor : sabor;
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-vy-caja2]'), function (caja) {
    var datos;
    try { datos = JSON.parse(caja.querySelector('[data-vy-caja2-datos]').textContent); } catch (e) { return; }
    var forma = caja.querySelector('form');
    var nojs = caja.querySelector('[data-vy-nojs]');
    var id = document.createElement('input');
    id.type = 'hidden'; id.name = 'id';
    if (nojs) { nojs.name = ''; nojs.hidden = true; nojs.parentNode.insertBefore(id, nojs); }
    caja.classList.add('vy-caja2--js');

    var cards = caja.querySelectorAll('[data-vy-planes2] .vy-p2');
    var btn = caja.querySelector('[data-vy-sel-btn]');
    var lista = caja.querySelector('[data-vy-sel-lista]');
    var porPlan = {};
    datos.variantes.forEach(function (v) { (porPlan[v.plan] = porPlan[v.plan] || []).push(v); });

    var ini = datos.variantes.filter(function (v) { return v.id === datos.inicial; })[0] || datos.variantes[0];
    var estado = { plan: ini.plan, sabor: ini.sabor, base: /vanilla/i.test(ini.sabor) && !/\+/.test(ini.sabor) ? 'V' : 'C' };
    var nDe = function (plan) { return datos.planes.indexOf(plan) + 1; };

    function porDefecto(plan) {
      var n = nDe(plan), opciones = porPlan[plan] || [];
      var base = estado.base === 'V' ? 'Cinnamon Vanilla' : 'Cinnamon Cacao';
      /* 2026-10-08 (Eduardo): el selector «sigue igual» — todas las bolsas del sabor que ya
         traía; la mezcla se arma dentro del selector con las cantidades. */
      if (n === 1 || opciones.some(function (v) { return v.sabor === base && v.disponible; })) return base;
      var mezclas = opciones.filter(function (v) { return /\+/.test(v.sabor) && v.disponible; });
      if (mezclas.length) {
        var pref = mezclas.filter(function (v) {
          var c = composicion(v.sabor, n), nc = c.filter(function (x) { return x === 'C'; }).length;
          return estado.base === 'V' ? nc <= n / 2 : nc >= n / 2;
        });
        return (pref[0] || mezclas[0]).sabor;
      }
      return (opciones[0] || {}).sabor;
    }
    function variante() {
      return (porPlan[estado.plan] || []).filter(function (v) { return v.sabor === estado.sabor; })[0];
    }
    function minis(arr, alto) {
      return arr.map(function (x) { return '<img src="' + datos.img[x] + '" alt="" height="' + alto + '">'; }).join('');
    }
    function pintarLista() {
      var n = nDe(estado.plan);
      if (n > 1) {
        var comp = composicion(estado.sabor, n), c = comp.filter(function (x) { return x === 'C'; }).length, v = n - c;
        var fila = function (k, nombre, cuantos) {
          return '<li class="vy-sel__cant" data-k="' + k + '"><span class="vy-sel__minis"><img src="' + datos.img[k] + '" alt="" height="30"></span><span class="vy-sel__nom">' + nombre + '</span>' +
            '<span class="vy-cont__stp"><button type="button" data-k="' + k + '" data-d="-1" aria-label="Una ' + nombre + ' menos"' + (cuantos === 0 ? ' disabled' : '') + '>−</button>' +
            '<b aria-live="polite">' + cuantos + '</b><button type="button" data-k="' + k + '" data-d="1" aria-label="Una ' + nombre + ' más"' + (cuantos === n ? ' disabled' : '') + '>+</button></span></li>';
        };
        lista.innerHTML = fila('C', 'Cinnamon Cacao', c) + fila('V', 'Cinnamon Vanilla', v) + '<li class="vy-sel__nota">Elige cuántas de cada sabor · ' + n + ' bolsas</li>';
        Array.prototype.forEach.call(lista.querySelectorAll('button'), function (b) {
          b.addEventListener('click', function (e) {
            e.stopPropagation();
            var d = +b.getAttribute('data-d'), k = b.getAttribute('data-k');
            var nc = k === 'C' ? c + d : c - d;
            if (nc < 0 || nc > n) return;
            var s = saborDe(nc, n - nc);
            if (!(porPlan[estado.plan] || []).some(function (x) { return x.sabor === s; })) return;
            estado.sabor = s; pintar(); pintarLista();
            var otra = lista.querySelector('button[data-k="' + k + '"][data-d="' + d + '"]'); if (otra && !otra.disabled) otra.focus();
          });
        });
        return;
      }
      lista.innerHTML = (porPlan[estado.plan] || []).map(function (v, i) {
        return '<li role="option" tabindex="-1" id="' + forma.id + '-op-' + i + '" data-sabor="' + v.sabor.replace(/"/g, '&quot;') + '" aria-selected="' + (v.sabor === estado.sabor) + '"' + (v.disponible ? '' : ' aria-disabled="true"') + '>' +
          '<span class="vy-sel__minis">' + minis(composicion(v.sabor, n), 30) + '</span><span>' + etiqueta(v.sabor, n) + '</span></li>';
      }).join('');
    }
    function pintar() {
      var v = variante(); if (!v) return;
      var n = nDe(estado.plan);
      id.value = v.id;
      Array.prototype.forEach.call(cards, function (c) {
        var on = c.getAttribute('data-plan') === estado.plan;
        c.classList.toggle('vy-p2--on', on); c.setAttribute('aria-checked', on);
        var cn = +c.getAttribute('data-n');
        c.querySelector('[data-minis]').innerHTML = minis(on ? composicion(estado.sabor, n) : composicion(porDefectoSinEstado(c.getAttribute('data-plan')), cn), 52);
      });
      /* 1 bolsa → desplegable · 2 o 3 → contador ligado (decisión de Eduardo, 2026-10-07) */
      var sel = caja.querySelector('[data-vy-sel]'), cont = caja.querySelector('[data-vy-cont]');
      sel.hidden = false; cont.hidden = true;
      caja.querySelector('[data-vy-sel-txt]').textContent = etiqueta(estado.sabor, n);
      caja.querySelector('[data-vy-sel-minis]').innerHTML = minis(composicion(estado.sabor, n), 30);
      caja.querySelector('[data-vy-total]').textContent = dinero(v.precio);
      caja.querySelector('[data-vy-total-txt]').textContent = 'Total';
      var lis = caja.querySelector('[data-vy-listo]'); if (lis) lis.textContent = n * 30;
      var ahorro = datos.suelta * n - v.precio;
      var vyNoches = caja.querySelector('[data-vy-noches]');
      if (vyNoches) vyNoches.textContent = (n * 30) + ' noches de ritual' + (ahorro > 0 ? ' · ahorras ' + dinero(ahorro) : '');
      var cta = forma.querySelector('button[type="submit"]');
      if (cta) cta.disabled = !v.disponible;
    }
    /* El contador: Cacao y Vanilla suman SIEMPRE n. Subir uno baja el otro. La
       combinación resultante se traduce al nombre de la variante que existe en
       Shopify: n·Cacao → «Cinnamon Cacao», n·Vanilla → «Cinnamon Vanilla»,
       mezcla → «c Cacao + v Vanilla». */
    function saborDe(c, v) {
      if (v === 0) return 'Cinnamon Cacao';
      if (c === 0) return 'Cinnamon Vanilla';
      return c + ' Cacao + ' + v + ' Vanilla';
    }
    function pintarContador(n) {
      var comp = composicion(estado.sabor, n);
      var c = comp.filter(function (x) { return x === 'C'; }).length, v = n - c;
      var cont = caja.querySelector('[data-vy-cont]');
      var fila = function (k, nombre, cuantos) {
        return '<div class="vy-cont__fila"><span class="vy-cont__n"><img src="' + datos.img[k] + '" alt="" height="40">' + nombre + '</span>' +
          '<span class="vy-cont__stp"><button type="button" data-k="' + k + '" data-d="-1" aria-label="Una ' + nombre + ' menos"' + (cuantos === 0 ? ' disabled' : '') + '>−</button>' +
          '<b aria-live="polite">' + cuantos + '</b><button type="button" data-k="' + k + '" data-d="1" aria-label="Una ' + nombre + ' más"' + (cuantos === n ? ' disabled' : '') + '>+</button></span></div>';
      };
      cont.innerHTML = fila('C', 'Cinnamon Cacao', c) + fila('V', 'Cinnamon Vanilla', v) +
        '<p class="vy-cont__nota">' + n + ' bolsas · ' + (c && v ? c + ' Cacao + ' + v + ' Vanilla' : (c ? n + ' Cacao' : n + ' Vanilla')) + '</p>';
      Array.prototype.forEach.call(cont.querySelectorAll('button'), function (b) {
        b.addEventListener('click', function () {
          var d = +b.getAttribute('data-d'), k = b.getAttribute('data-k');
          var nc = k === 'C' ? c + d : c - d;
          if (nc < 0 || nc > n) return;
          var s = saborDe(nc, n - nc);
          if (!(porPlan[estado.plan] || []).some(function (x) { return x.sabor === s; })) return;
          estado.sabor = s; pintar();
        });
      });
    }

    function porDefectoSinEstado(plan) {
      var guard = estado.plan; var s = porDefecto(plan); estado.plan = guard; return s;
    }

    /* tarjetas */
    Array.prototype.forEach.call(cards, function (c) {
      c.addEventListener('click', function () {
        if (estado.plan === c.getAttribute('data-plan')) return;
        estado.plan = c.getAttribute('data-plan');
        estado.sabor = porDefecto(estado.plan);
        pintar(); cerrar();
      });
    });

    /* desplegable (listbox accesible: Enter/Espacio abre, flechas mueven, Esc cierra) */
    function abrir() { pintarLista(); lista.hidden = false; btn.setAttribute('aria-expanded', 'true'); var s = lista.querySelector('[aria-selected="true"]') || lista.querySelector('[role="option"], button:not([disabled])'); if (s) s.focus(); }
    function cerrar() { if (lista.hidden) return; lista.hidden = true; btn.setAttribute('aria-expanded', 'false'); }
    function elegir(li) {
      if (!li || li.getAttribute('aria-disabled') === 'true') return;
      estado.sabor = li.getAttribute('data-sabor');
      if (nDe(estado.plan) === 1) estado.base = /vanilla/i.test(estado.sabor) ? 'V' : 'C';
      pintar(); cerrar(); btn.focus();
    }
    btn.addEventListener('click', function () { lista.hidden ? abrir() : cerrar(); });
    lista.addEventListener('click', function (e) { elegir(e.target.closest('[role="option"]')); });
    lista.addEventListener('keydown', function (e) {
      var items = Array.prototype.slice.call(lista.querySelectorAll('[role="option"]'));
      var i = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || items[0]).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); (items[i - 1] || items[items.length - 1]).focus(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); elegir(document.activeElement); }
      else if (e.key === 'Escape' || e.key === 'Tab') { cerrar(); btn.focus(); }
    });
    document.addEventListener('click', function (e) { if (!caja.querySelector('[data-vy-sel]').contains(e.target)) cerrar(); });

    pintar();
  });
})();
